export const version = 1;

export const hoursUntilStale = 0.25;
